import { Stack, Text } from '@sixui/ui';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';

export type IContentBlockInfoListItemProps = IContainerProps & {
  label: React.ReactNode;
  supportingText?: React.ReactNode;
  children: React.ReactNode;
  actions?: React.ReactNode;
};

const styles = stylex.create({
  labelContainer: {
    textAlign: 'right',
  },
  description: {
    display: 'flex',
    alignItems: 'center',
  },
  value: {
    flexGrow: 1,
  },
  actions: {
    marginLeft: '1rem',
    flexShrink: 0,
  },
});

export const ContentBlockInfoListItem: React.FC<
  IContentBlockInfoListItemProps
> = (props) => {
  const { label, supportingText, children, actions } = props;

  return (
    <>
      <Stack as="dt" gap={1} sx={styles.labelContainer}>
        {label ? (
          <Text variant="label" size="lg" truncate>
            {label}
          </Text>
        ) : null}
        {supportingText ? (
          <Text variant="body" size="sm" dimmed>
            {supportingText}
          </Text>
        ) : null}
      </Stack>

      <dd {...stylex.props(styles.description)}>
        {children ? (
          <span {...stylex.props(styles.value)}>{children}</span>
        ) : null}
        {actions ? (
          <Stack horizontal gap={2} sx={styles.actions}>
            {actions}
          </Stack>
        ) : null}
      </dd>
    </>
  );
};
